export default __webpack_public_path__ + "static/media/psu-stidti-regular.d2ef0fee.ttf";